import React from "react"
import Layout from "../components/layout"
import WebvrShowroom from '../components/WebvrShowroom'
import Instructions from '../components/Instructions'
import Heroes from '../components/Heroes/'
import Banner from "../components/Banner/banner"
import TextBlock from "../components/TextBlock/textBlock"
import TextBlockImg from "../components/TextBlockImg/textBlockImg"
import Button from "../components/Button/button"
import Contact from "../components/Contact/contact"
import { Link, animateScroll as scroll } from 'react-scroll'

import heroImage1 from "../images/hero-images/5.2.20_factor_chair_settings_Factor.457_09242020.jpg"
import heroImage2 from "../images/hero-images/5.2.20_factor_table_studio_Factor.TA1_.408_09242020.jpg"
import aptosPedestrian1 from '../images/hero-images/aptos-pedestrian/ASLA_Aptos_1.png'
import aptosPedestrian2 from '../images/hero-images/aptos-pedestrian/ASLA_Aptos_2.png'
import aptosPedestrian3 from '../images/hero-images/aptos-pedestrian/ASLA_Aptos_3.png'
import aptosBollard1 from '../images/hero-images/aptos-bollard/ASLA_AptosBollard_1.png'
import aptosBollard2 from '../images/hero-images/aptos-bollard/ASLA_AptosBollard_2.png'
import aptosBollard3 from '../images/hero-images/aptos-bollard/ASLA_AptosBollard_3.png'
import helioBollard1 from '../images/hero-images/helio-security-bollard/ASLA_Helio_1.png'
import helioBollard2 from '../images/hero-images/helio-security-bollard/ASLA_Helio_2.png'
import helioBollard3 from '../images/hero-images/helio-security-bollard/ASLA_Helio_3.png'
import tonyoReceptacle1 from '../images/hero-images/tonyo-receptacle/ASLA_Tonyo_1.png'
import tonyoReceptacle2 from '../images/hero-images/tonyo-receptacle/ASLA_Tonyo_2.png'
import tonyoReceptacle3 from '../images/hero-images/tonyo-receptacle/ASLA_Tonyo_3.png'
import liniaChair1 from '../images/hero-images/linia-chair/ASLA_Linia_1a.png'
import liniaChair2 from '../images/hero-images/linia-chair/ASLA_Linia_2.png'
import liniaChair3 from '../images/hero-images/linia-chair/ASLA_Linia_3.png'
import tenza1 from '../images/hero-images/tenza-charging-solution/ASLA_Tenza_1a.png'
import tenza2 from '../images/hero-images/tenza-charging-solution/ASLA_Tenza_2a.png'
import tenza3 from '../images/hero-images/tenza-charging-solution/ASLA_Tenza_3.png'
import radia1 from '../images/hero-images/radia-bollard/ASLA_Radia_1.png'
import radia2 from '../images/hero-images/radia-bollard/ASLA_Radia_2.png'
import radia3 from '../images/hero-images/radia-bollard/ASLA_Radia_3a.png'
import liniaLounge1 from '../images/hero-images/linia-lounge/ASLA_LiniaLounge_2.png'
import liniaLounge2 from '../images/hero-images/linia-lounge/ASLA_LiniaLounge_1.png'
import liniaLounge3 from '../images/hero-images/linia-lounge/ASLA_LiniaLounge_3.png'

export default () => (
  <>
    <Layout>
      <WebvrShowroom/>
      <Heroes>
        <div
        label="LINIA CAFÉ CHAIRS & SIDE TABLE"
        heroId="linia-chair"
        >
          <div bigImage={liniaChair1} bgColor='#c9c4b3'>
            <h2 className='hero-title mobile-title'>LINIA CAFÉ CHAIRS & SIDE TABLE</h2>
            <h2 className='hero-title'>LINIA CAFÉ CHAIRS & SIDE TABLE</h2>
            <p>Linia Café Chairs, Lounge Chairs & Side Tables invite easy customization and offer the exceptional performance of stainless steel.</p>
            <div className='heroTextInner'>
              <ul>
                <li>Stainless steel rod frames have an electropolished or powdercoat finish</li>
                <li>Stainless steel chair seats & backs and table tops have a powdercoat finish</li>
                <li>Powdercoat colors can be mixed or matched on individual chairs/tables</li>
                <li>Chair seats and table tops are available with or without perforations</li>
                <li>Chairs stack up to 4 high</li>
                <li>Café Chairs have an upright form for use with café tables</li>
                <li>Lounge Chairs have a wider, more relaxed profile</li>
                <li>Side Table is nom. 18” high with 17” dia. top</li>
                <li>Freestanding; nylon glides on chair and table feet</li>
                <li>High recycled content; highly recyclable</li>
                <li>For interior and exterior use</li>
              </ul>
            </div>
            <p><a href="https://www.forms-surfaces.com/linia-chairs-and-tables" target="_NEW">LEARN MORE</a></p>
          </div>
          <div bigImage={liniaChair2} bgColor='#29534f'>
            <h2 className='hero-title mobile-title'>LINIA CAFÉ CHAIRS & SIDE TABLE</h2>
            <h2 className='hero-title'>LINIA CAFÉ CHAIRS & SIDE TABLE</h2>
            <p>Linia Café Chairs, Lounge Chairs & Side Tables invite easy customization and offer the exceptional performance of stainless steel.</p>
            <div className='heroTextInner'>
              <ul>
                <li>Stainless steel rod frames have an electropolished or powdercoat finish</li>
                <li>Stainless steel chair seats & backs and table tops have a powdercoat finish</li>
                <li>Powdercoat colors can be mixed or matched on individual chairs/tables</li>
                <li>Chair seats and table tops are available with or without perforations</li>
                <li>Chairs stack up to 4 high</li>
                <li>Café Chairs have an upright form for use with café tables</li>
                <li>Lounge Chairs have a wider, more relaxed profile</li>
                <li>Side Table is nom. 18” high with 17” dia. top</li>
                <li>Freestanding; nylon glides on chair and table feet</li>
                <li>High recycled content; highly recyclable</li>
                <li>For interior and exterior use</li>
              </ul>
            </div>
            <p><a href="https://www.forms-surfaces.com/linia-chairs-and-tables" target="_NEW">LEARN MORE</a></p>
          </div>
          <div bigImage={liniaChair3} bgColor='#3f4448'>
            <h2 className='hero-title mobile-title'>LINIA CAFÉ CHAIRS & SIDE TABLE</h2>
            <h2 className='hero-title'>LINIA CAFÉ CHAIRS & SIDE TABLE</h2>
            <p>Linia Café Chairs, Lounge Chairs & Side Tables invite easy customization and offer the exceptional performance of stainless steel.</p>
            <div className='heroTextInner'>
              <ul>
                <li>Stainless steel rod frames have an electropolished or powdercoat finish</li>
                <li>Stainless steel chair seats & backs and table tops have a powdercoat finish</li>
                <li>Powdercoat colors can be mixed or matched on individual chairs/tables</li>
                <li>Chair seats and table tops are available with or without perforations</li>
                <li>Chairs stack up to 4 high</li>
                <li>Café Chairs have an upright form for use with café tables</li>
                <li>Lounge Chairs have a wider, more relaxed profile</li>
                <li>Side Table is nom. 18” high with 17” dia. top</li>
                <li>Freestanding; nylon glides on chair and table feet</li>
                <li>High recycled content; highly recyclable</li>
                <li>For interior and exterior use</li>
              </ul>
            </div>
            <p><a href="https://www.forms-surfaces.com/linia-chairs-and-tables" target="_NEW">LEARN MORE</a></p>
          </div>
        </div>
        <div
        label="LINIA LOUNGE CHAIRS & SIDE TABLES"
        heroId="linia-lounge"
        >
          <div bigImage={liniaLounge1} bgColor='#626d6f'>
            <h2 className='hero-title mobile-title'>LINIA LOUNGE CHAIRS & SIDE TABLES</h2>
            <h2 className='hero-title'>LINIA LOUNGE CHAIRS & SIDE TABLES</h2>
            <p>Linia Café Chairs, Lounge Chairs & Side Tables invite easy customization and offer the exceptional performance of stainless steel.</p>
            <div className='heroTextInner'>
              <ul>
                <li>Stainless steel rod frames have an electropolished or powdercoat finish</li>
                <li>Stainless steel chair seats & backs and table tops have a powdercoat finish</li>
                <li>Powdercoat colors can be mixed or matched on individual chairs/tables</li>
                <li>Chair seats and table tops are available with or without perforations</li>
                <li>Chairs stack up to 4 high</li>
                <li>Café Chairs have an upright form for use with café tables</li>
                <li>Lounge Chairs have a wider, more relaxed profile</li>
                <li>Side Table is nom. 18” high with 17” dia. top</li>
                <li>Freestanding; nylon glides on chair and table feet</li>
                <li>High recycled content; highly recyclable</li>
                <li>For interior and exterior use</li>
              </ul>
            </div>
            <p><a href="https://www.forms-surfaces.com/linia-chairs-and-tables" target="_NEW">LEARN MORE</a></p>
          </div>
          <div bigImage={liniaLounge2} bgColor='#cac4b4'>
            <h2 className='hero-title mobile-title'>LINIA LOUNGE CHAIRS & SIDE TABLES</h2>
            <h2 className='hero-title'>LINIA LOUNGE CHAIRS & SIDE TABLES</h2>
            <p>Linia Café Chairs, Lounge Chairs & Side Tables invite easy customization and offer the exceptional performance of stainless steel.</p>
            <div className='heroTextInner'>
              <ul>
                <li>Stainless steel rod frames have an electropolished or powdercoat finish</li>
                <li>Stainless steel chair seats & backs and table tops have a powdercoat finish</li>
                <li>Powdercoat colors can be mixed or matched on individual chairs/tables</li>
                <li>Chair seats and table tops are available with or without perforations</li>
                <li>Chairs stack up to 4 high</li>
                <li>Café Chairs have an upright form for use with café tables</li>
                <li>Lounge Chairs have a wider, more relaxed profile</li>
                <li>Side Table is nom. 18” high with 17” dia. top</li>
                <li>Freestanding; nylon glides on chair and table feet</li>
                <li>High recycled content; highly recyclable</li>
                <li>For interior and exterior use</li>
              </ul>
            </div>
            <p><a href="https://www.forms-surfaces.com/linia-chairs-and-tables" target="_NEW">LEARN MORE</a></p>
          </div>
          <div bigImage={liniaLounge3} bgColor='#8d4131'>
            <h2 className='hero-title mobile-title'>LINIA LOUNGE CHAIRS & SIDE TABLES</h2>
            <h2 className='hero-title'>LINIA LOUNGE CHAIRS & SIDE TABLES</h2>
            <p>Linia Café Chairs, Lounge Chairs & Side Tables invite easy customization and offer the exceptional performance of stainless steel.</p>
            <div className='heroTextInner'>
              <ul>
                <li>Stainless steel rod frames have an electropolished or powdercoat finish</li>
                <li>Stainless steel chair seats & backs and table tops have a powdercoat finish</li>
                <li>Powdercoat colors can be mixed or matched on individual chairs/tables</li>
                <li>Chair seats and table tops are available with or without perforations</li>
                <li>Chairs stack up to 4 high</li>
                <li>Café Chairs have an upright form for use with café tables</li>
                <li>Lounge Chairs have a wider, more relaxed profile</li>
                <li>Side Table is nom. 18” high with 17” dia. top</li>
                <li>Freestanding; nylon glides on chair and table feet</li>
                <li>High recycled content; highly recyclable</li>
                <li>For interior and exterior use</li>
              </ul>
            </div>
            <p><a href="https://www.forms-surfaces.com/linia-chairs-and-tables" target="_NEW">LEARN MORE</a></p>
          </div>
      </div>
      <div
      label="TONYO RECEPTACLE"
      heroId="tonyo-receptacle"
      >
        <div bigImage={tonyoReceptacle1} bgColor='#959498'>
          <h2 className='hero-title mobile-title'>TONYO RECEPTACLE</h2>
          <h2 className='hero-title'>TONYO RECEPTACLE</h2>
          <p>Tonyo Litter & Recycling Receptacles are a durable, beautifully modern solution for a wide range of settings and waste collection needs.</p>
          <div className='heroTextInner'>
            <ul>
              <li>Bodies and doors in powdercoated stainless steel with or without optional perforation patterns or FSC® 100% Cumaru hardwood slats</li>
              <li>Lids, sidebars, bases, and rain hats in powdercoated aluminum</li>
              <li>30, 36 and 60-gallon capacities, each with its own configurable design options</li>
              <li>Single- and split-stream variations</li>
              <li>Optional waste stream graphics</li>
              <li>Opportunities for color-blocking and custom branding & graphics</li>
              <li>Hinged side-access doors for easy servicing</li>
              <li>Multiple mounting options</li>
              <li>Components are recyclable</li>
            </ul>
          </div>
          <p><a href="https://www.forms-surfaces.com/tonyo-litter-recycling-receptacle" target="_NEW">LEARN MORE</a></p>
        </div>
        <div bigImage={tonyoReceptacle2} bgColor='#504B49'>
          <h2 className='hero-title mobile-title'>TONYO RECEPTACLE</h2>
          <h2 className='hero-title'>TONYO RECEPTACLE</h2>
          <p>Tonyo Litter & Recycling Receptacles are a durable, beautifully modern solution for a wide range of settings and waste collection needs.</p>
          <div className='heroTextInner'>
            <ul>
              <li>Bodies and doors in powdercoated stainless steel with or without optional perforation patterns or FSC® 100% Cumaru hardwood slats</li>
              <li>Lids, sidebars, bases, and rain hats in powdercoated aluminum</li>
              <li>30, 36 and 60-gallon capacities, each with its own configurable design options</li>
              <li>Single- and split-stream variations</li>
              <li>Optional waste stream graphics</li>
              <li>Opportunities for color-blocking and custom branding & graphics</li>
              <li>Hinged side-access doors for easy servicing</li>
              <li>Multiple mounting options</li>
              <li>Components are recyclable</li>
            </ul>
          </div>
          <p><a href="https://www.forms-surfaces.com/tonyo-litter-recycling-receptacle" target="_NEW">LEARN MORE</a></p>
        </div>
        <div bigImage={tonyoReceptacle3} bgColor='#626d6f'>
          <h2 className='hero-title mobile-title'>TONYO RECEPTACLE</h2>
          <h2 className='hero-title'>TONYO RECEPTACLE</h2>
          <p>Tonyo Litter & Recycling Receptacles are a durable, beautifully modern solution for a wide range of settings and waste collection needs.</p>
          <div className='heroTextInner'>
            <ul>
              <li>Bodies and doors in powdercoated stainless steel with or without optional perforation patterns or FSC® 100% Cumaru hardwood slats</li>
              <li>Lids, sidebars, bases, and rain hats in powdercoated aluminum</li>
              <li>30, 36 and 60-gallon capacities, each with its own configurable design options</li>
              <li>Single- and split-stream variations</li>
              <li>Optional waste stream graphics</li>
              <li>Opportunities for color-blocking and custom branding & graphics</li>
              <li>Hinged side-access doors for easy servicing</li>
              <li>Multiple mounting options</li>
              <li>Components are recyclable</li>
            </ul>
          </div>
          <p><a href="https://www.forms-surfaces.com/tonyo-litter-recycling-receptacle" target="_NEW">LEARN MORE</a></p>
        </div>
      </div>
      <div
      label="TENZA CHARGING SOLUTION"
      heroId="tenza"
      >
        <div bigImage={tenza1} bgColor='#444a3e'>
          <h2 className='hero-title mobile-title'>TENZA CHARGING SOLUTION</h2>
          <h2 className='hero-title'>TENZA CHARGING SOLUTION</h2>
          <p>PRODUCT PREVIEW | The Tenza Charging Solution offers power in any space, indoor or outdoor, in an eye-catching, inviting form.</p>
          <div className='heroTextInner'>
            <ul>
              <li>Constructed of corrosion-resistant cast aluminum and stainless steel</li>
              <li>Durable powdercoat finish</li>
              <li>36.5" or 53" tall, for seated or standing-height applications</li>
              <li>Convenient, optional shelves</li>
              <li>Self-closing, easy to use, safe outlet housing</li>
              <li>Distinctive wedge-shaped enclosure is inviting and easy to identify in a space</li>
              <li>LED illuminated outlet housing for ease of use</li>
              <li>Standard GFCI outlets</li>
              <li>Meets NEMA 3R and ETL listed for wet locations</li>
              <li>High recycled content; highly recyclable</li>
              <li>Launching in 2022</li>
            </ul>
          </div>
          <p><a href="#contact">KEEP ME POSTED</a></p>
        </div>
        <div bigImage={tenza2} bgColor='#626d6f'>
          <h2 className='hero-title mobile-title'>TENZA CHARGING SOLUTION</h2>
          <h2 className='hero-title'>TENZA CHARGING SOLUTION</h2>
          <p>PRODUCT PREVIEW | The Tenza Charging Solution offers power in any space, indoor or outdoor, in an eye-catching, inviting form.</p>
          <div className='heroTextInner'>
            <ul>
              <li>Constructed of corrosion-resistant cast aluminum and stainless steel</li>
              <li>Durable powdercoat finish</li>
              <li>36.5" or 53" tall, for seated or standing-height applications</li>
              <li>Convenient, optional shelves</li>
              <li>Self-closing, easy to use, safe outlet housing</li>
              <li>Distinctive wedge-shaped enclosure is inviting and easy to identify in a space</li>
              <li>LED illuminated outlet housing for ease of use</li>
              <li>Standard GFCI outlets</li>
              <li>Meets NEMA 3R and ETL listed for wet locations</li>
              <li>High recycled content; highly recyclable</li>
              <li>Launching in 2022</li>
            </ul>
          </div>
          <p><a href="#contact">KEEP ME POSTED</a></p>
        </div>
        <div bigImage={tenza3} bgColor='#8d4131'>
          <h2 className='hero-title mobile-title'>TENZA CHARGING SOLUTION</h2>
          <h2 className='hero-title'>TENZA CHARGING SOLUTION</h2>
          <p>PRODUCT PREVIEW | The Tenza Charging Solution offers power in any space, indoor or outdoor, in an eye-catching, inviting form.</p>
          <div className='heroTextInner'>
            <ul>
              <li>Constructed of corrosion-resistant cast aluminum and stainless steel</li>
              <li>Durable powdercoat finish</li>
              <li>36.5" or 53" tall, for seated or standing-height applications</li>
              <li>Convenient, optional shelves</li>
              <li>Self-closing, easy to use, safe outlet housing</li>
              <li>Distinctive wedge-shaped enclosure is inviting and easy to identify in a space</li>
              <li>LED illuminated outlet housing for ease of use</li>
              <li>Standard GFCI outlets</li>
              <li>Meets NEMA 3R and ETL listed for wet locations</li>
              <li>High recycled content; highly recyclable</li>
              <li>Launching in 2022</li>
            </ul>
          </div>
          <p><a href="#contact">KEEP ME POSTED</a></p>
        </div>
      </div>
      <div
      label="HELIO SECURITY BOLLARD"
      heroId="helio-security-bollard"
      >
        <div bigImage={helioBollard1} bgColor='#c5c1be'>
          <h2 className='hero-title mobile-title'>HELIO SECURITY BOLLARD</h2>
          <h2 className='hero-title'>HELIO SECURITY BOLLARD</h2>
          <p>Helio Security Bollards offer robust protection for public spaces of all kinds with fixtures in multiple sizes and security core variations.</p>
          <div className='heroTextInner'>
            <ul>
              <li>Stainless steel construction</li>
              <li>Satin finish with protective Ceramiloc treatment</li>
              <li>Durable powdercoat finish also available</li>
              <li>All bollards are 40" high</li>
              <li>Column diameter is 6" for SC30-P1; 9.25" for M30-P1/K4; and 11.5" for M40-P1/K8 and M50-P1/K12 security cores</li>
              <li>Custom LED light engine with Cree® LEDs in 3000K warm white and 4000K neutral white</li>
              <li>180° or 360° light distribution options</li>
              <li>Non-illuminated versions also available</li>
              <li>ETL and C-ETL listed</li>
              <li>High recycled content; highly recyclable</li>
            </ul>
          </div>
          <p><a href="https://www.forms-surfaces.com/security-bollards" target="_NEW">LEARN MORE</a></p>
        </div>
        <div bigImage={helioBollard2} bgColor='#c9c4b3'>
          <h2 className='hero-title mobile-title'>HELIO SECURITY BOLLARD</h2>
          <h2 className='hero-title'>HELIO SECURITY BOLLARD</h2>
          <p>Helio Security Bollards offer robust protection for public spaces of all kinds with fixtures in multiple sizes and security core variations.</p>
          <div className='heroTextInner'>
            <ul>
              <li>Stainless steel construction</li>
              <li>Satin finish with protective Ceramiloc treatment</li>
              <li>Durable powdercoat finish also available</li>
              <li>All bollards are 40" high</li>
              <li>Column diameter is 6" for SC30-P1; 9.25" for M30-P1/K4; and 11.5" for M40-P1/K8 and M50-P1/K12 security cores</li>
              <li>Custom LED light engine with Cree® LEDs in 3000K warm white and 4000K neutral white</li>
              <li>180° or 360° light distribution options</li>
              <li>Non-illuminated versions also available</li>
              <li>ETL and C-ETL listed</li>
              <li>High recycled content; highly recyclable</li>
            </ul>
          </div>
          <p><a href="https://www.forms-surfaces.com/security-bollards" target="_NEW">LEARN MORE</a></p>
        </div>
        <div bigImage={helioBollard3} bgColor='#2F2D2B'>
          <h2 className='hero-title mobile-title'>HELIO SECURITY BOLLARD</h2>
          <h2 className='hero-title'>HELIO SECURITY BOLLARD</h2>
          <p>Helio Security Bollards offer robust protection for public spaces of all kinds with fixtures in multiple sizes and security core variations.</p>
          <div className='heroTextInner'>
            <ul>
              <li>Stainless steel construction</li>
              <li>Satin finish with protective Ceramiloc treatment</li>
              <li>Durable powdercoat finish also available</li>
              <li>All bollards are 40" high</li>
              <li>Column diameter is 6" for SC30-P1; 9.25" for M30-P1/K4; and 11.5" for M40-P1/K8 and M50-P1/K12 security cores</li>
              <li>Custom LED light engine with Cree® LEDs in 3000K warm white and 4000K neutral white</li>
              <li>180° or 360° light distribution options</li>
              <li>Non-illuminated versions also available</li>
              <li>ETL and C-ETL listed</li>
              <li>High recycled content; highly recyclable</li>
            </ul>
          </div>
          <p><a href="https://www.forms-surfaces.com/security-bollards" target="_NEW">LEARN MORE</a></p>
        </div>
      </div>
      <div
      label="RADIA BOLLARD"
      heroId="solar-bollard"
      >
        <div bigImage={radia1} bgColor='#3f4448'>
          <h2 className='hero-title mobile-title'>RADIA BOLLARD</h2>
          <h2 className='hero-title'>RADIA BOLLARD</h2>
          <p>PRODUCT PREVIEW | The Radia Family is defined by a cove form, faceted exterior, and 180° light distribution. Three bollard styles comprise the line.</p>
          <div className='heroTextInner'>
            <ul>
              <li>Fixtures consist of corrosion-resistant cast aluminum, aluminum extrusion, and acrylic lens</li>
            	<li>Durable powdercoat finish</li>
            	<li>Solar-powered bollard is 36" high x 6.5" diameter</li>
            	<li>AC bollard is 27.5" high x 4.25" diameter</li>
            	<li>AC pathway bollard is 10" high x 4.25" diameter</li>
            	<li>Performance LEDs in 3000K warm white and 4000K neutral white with individual mounted optics</li>
            	<li>Solar module has high-efficiency monocrystalline cells encapsulated in high-impact UV-resistant polyurethane</li>
            	<li>180° light distribution</li>
            	<li>ETL and C-ETL listed for wet locations</li>
            	<li>High recycled content; highly recyclable</li>
            	<li>Launching early 2022</li>
            </ul>
          </div>
          <p><a href="#contact">KEEP ME POSTED</a></p>
        </div>
        <div bigImage={radia2} bgColor='#29534f'>
          <h2 className='hero-title mobile-title'>RADIA BOLLARD</h2>
          <h2 className='hero-title'>RADIA BOLLARD</h2>
          <p>PRODUCT PREVIEW | The Radia Family is defined by a cove form, faceted exterior, and 180° light distribution. Three bollard styles comprise the line.</p>
          <div className='heroTextInner'>
            <ul>
              <li>Fixtures consist of corrosion-resistant cast aluminum, aluminum extrusion, and acrylic lens</li>
              <li>Durable powdercoat finish</li>
              <li>Solar-powered bollard is 36" high x 6.5" diameter</li>
              <li>AC bollard is 27.5" high x 4.25" diameter</li>
              <li>AC pathway bollard is 10" high x 4.25" diameter</li>
              <li>Performance LEDs in 3000K warm white and 4000K neutral white with individual mounted optics</li>
              <li>Solar module has high-efficiency monocrystalline cells encapsulated in high-impact UV-resistant polyurethane</li>
              <li>180° light distribution</li>
              <li>ETL and C-ETL listed for wet locations</li>
              <li>High recycled content; highly recyclable</li>
              <li>Launching early 2022</li>
            </ul>
          </div>
          <p><a href="#contact">KEEP ME POSTED</a></p>
        </div>
        <div bigImage={radia3} bgColor='#877e75'>
          <h2 className='hero-title mobile-title'>RADIA BOLLARD</h2>
          <h2 className='hero-title'>RADIA BOLLARD</h2>
          <p>PRODUCT PREVIEW | The Radia Family is defined by a cove form, faceted exterior, and 180° light distribution. Three bollard styles comprise the line.</p>
          <div className='heroTextInner'>
            <ul>
              <li>Fixtures consist of corrosion-resistant cast aluminum, aluminum extrusion, and acrylic lens</li>
              <li>Durable powdercoat finish</li>
              <li>Solar-powered bollard is 36" high x 6.5" diameter</li>
              <li>AC bollard is 27.5" high x 4.25" diameter</li>
              <li>AC pathway bollard is 10" high x 4.25" diameter</li>
              <li>Performance LEDs in 3000K warm white and 4000K neutral white with individual mounted optics</li>
              <li>Solar module has high-efficiency monocrystalline cells encapsulated in high-impact UV-resistant polyurethane</li>
              <li>180° light distribution</li>
              <li>ETL and C-ETL listed for wet locations</li>
              <li>High recycled content; highly recyclable</li>
              <li>Launching early 2022</li>
            </ul>
          </div>
          <p><a href="#contact">KEEP ME POSTED</a></p>
        </div>
      </div>
      <div
      label="APTOS BOLLARD"
      heroId="aptos-bollard"
      >
        <div bigImage={aptosBollard1} bgColor='#97969b'>
          <h2 className='hero-title mobile-title'>APTOS BOLLARD</h2>
          <h2 className='hero-title'>APTOS BOLLARD</h2>
          <p>Aptos Bollards unite the best of two worlds with solar-powered and hardwired designs that coordinate beautifully with Aptos Pedestrian Lighting.</p>
          <div className='heroTextInner'>
            <ul>
              <li>Powdercoated cast aluminum body</li>
            	<li>36" high x 6.5" diameter</li>
            	<li>120° or 360° light distribution</li>
            	<li>Cree® LEDs in 3000K warm white + 4000K neutral white with individual mounted optics</li>
            	<li>Self-contained solar-powered bollard predictively adapts to surroundings</li>
            	<li>Self-learning Solar Lighting Controller with intelligent day/night detection</li>
            	<li>Solar module has high-efficiency monocrystalline cells encapsulated in high-impact UV-resistant polyurethane</li>
            	<li>Solar bollard has a high-performance lithium ion phosphate battery</li>
            	<li>Hardwired bollards have a 40W LED driver, are dimmable and ETL and C-ETL listed</li>
            	<li>High recycled content; highly recyclable</li>
            </ul>
          </div>
          <p><a href="https://www.forms-surfaces.com/aptos-bollard" target="_NEW">LEARN MORE</a></p>
        </div>
        <div bigImage={aptosBollard2} bgColor='#504b48'>
          <h2 className='hero-title mobile-title'>APTOS BOLLARD</h2>
          <h2 className='hero-title'>APTOS BOLLARD</h2>
          <p>Aptos Bollards unite the best of two worlds with solar-powered and hardwired designs that coordinate beautifully with Aptos Pedestrian Lighting.</p>
          <div className='heroTextInner'>
            <ul>
              <li>Powdercoated cast aluminum body</li>
            	<li>36" high x 6.5" diameter</li>
            	<li>120° or 360° light distribution</li>
            	<li>Cree® LEDs in 3000K warm white + 4000K neutral white with individual mounted optics</li>
            	<li>Self-contained solar-powered bollard predictively adapts to surroundings</li>
            	<li>Self-learning Solar Lighting Controller with intelligent day/night detection</li>
            	<li>Solar module has high-efficiency monocrystalline cells encapsulated in high-impact UV-resistant polyurethane</li>
            	<li>Solar bollard has a high-performance lithium ion phosphate battery</li>
            	<li>Hardwired bollards have a 40W LED driver, are dimmable and ETL and C-ETL listed</li>
            	<li>High recycled content; highly recyclable</li>
            </ul>
          </div>
          <p><a href="https://www.forms-surfaces.com/aptos-bollard" target="_NEW">LEARN MORE</a></p>
        </div>
        <div bigImage={aptosBollard3} bgColor='#626d6f'>
          <h2 className='hero-title mobile-title'>APTOS BOLLARD</h2>
          <h2 className='hero-title'>APTOS BOLLARD</h2>
          <p>Aptos Bollards unite the best of two worlds with solar-powered and hardwired designs that coordinate beautifully with Aptos Pedestrian Lighting.</p>
          <div className='heroTextInner'>
            <ul>
              <li>Powdercoated cast aluminum body</li>
              <li>36" high x 6.5" diameter</li>
              <li>120° or 360° light distribution</li>
              <li>Cree® LEDs in 3000K warm white + 4000K neutral white with individual mounted optics</li>
              <li>Self-contained solar-powered bollard predictively adapts to surroundings</li>
              <li>Self-learning Solar Lighting Controller with intelligent day/night detection</li>
              <li>Solar module has high-efficiency monocrystalline cells encapsulated in high-impact UV-resistant polyurethane</li>
              <li>Solar bollard has a high-performance lithium ion phosphate battery</li>
              <li>Hardwired bollards have a 40W LED driver, are dimmable and ETL and C-ETL listed</li>
              <li>High recycled content; highly recyclable</li>
            </ul>
          </div>
          <p><a href="https://www.forms-surfaces.com/aptos-bollard" target="_NEW">LEARN MORE</a></p>
        </div>
      </div>
      <div
      label="APTOS PEDESTRIAN LIGHTING"
      heroId="aptos-pedestrian"
      >
        <div bigImage={aptosPedestrian1} bgColor='#c5c1be'>
          <h2 className='hero-title mobile-title'>APTOS PEDESTRIAN LIGHTING</h2>
          <h2 className='hero-title'>APTOS PEDESTRIAN LIGHTING</h2>
          <p>Aptos Pedestrian Lighting blends graceful lines, performance LEDs, and the visual lightness and distinctive design of the coordinating Aptos Bollard.</p>
          <div className='heroTextInner'>
            <ul>
              <li>Fixtures consist of one or two luminaires on a pole 4" dia. x 12' high</li>
            	<li>Pole and luminaire(s) are a single unit</li>
            	<li>Pole is powdercoated aluminum</li>
            	<li>Luminaire head is cast aluminum, with optic and a frosted acrylic lens</li>
            	<li>Base is cast aluminum</li>
            	<li>Durable powdercoat finish</li>
            	<li>Performance Cree® LEDs in 3000K warm white and 4000K neutral white</li>
            	<li>Downward facing illumination for reduced light pollution and glare</li>
            	<li>Dimmable</li>
            	<li>High recycled content; highly recyclable</li>
            	<li>ETL and C-ETL listed for wet locations</li>
            </ul>
          </div>
          <p><a href="https://www.forms-surfaces.com/aptos-pedestrian" target="_NEW">LEARN MORE</a></p>
        </div>
        <div bigImage={aptosPedestrian2} bgColor='#C9C5B4'>
          <h2 className='hero-title mobile-title'>APTOS PEDESTRIAN LIGHTING</h2>
          <h2 className='hero-title'>APTOS PEDESTRIAN LIGHTING</h2>
          <p>Aptos Pedestrian Lighting blends graceful lines, performance LEDs, and the visual lightness and distinctive design of the coordinating Aptos Bollard.</p>
          <div className='heroTextInner'>
            <ul>
              <li>Fixtures consist of one or two luminaires on a pole 4" dia. x 12' high</li>
              <li>Pole and luminaire(s) are a single unit</li>
              <li>Pole is powdercoated aluminum</li>
              <li>Luminaire head is cast aluminum, with optic and a frosted acrylic lens</li>
              <li>Base is cast aluminum</li>
              <li>Durable powdercoat finish</li>
              <li>Performance Cree® LEDs in 3000K warm white and 4000K neutral white</li>
              <li>Downward facing illumination for reduced light pollution and glare</li>
              <li>Dimmable</li>
              <li>High recycled content; highly recyclable</li>
              <li>ETL and C-ETL listed for wet locations</li>
            </ul>
          </div>
          <p><a href="https://www.forms-surfaces.com/aptos-pedestrian" target="_NEW">LEARN MORE</a></p>
        </div>
        <div bigImage={aptosPedestrian3} bgColor='#3F4448'>
        <h2 className='hero-title mobile-title'>APTOS PEDESTRIAN LIGHTING</h2>
          <h2 className='hero-title'>APTOS PEDESTRIAN LIGHTING</h2>
          <p>Aptos Pedestrian Lighting blends graceful lines, performance LEDs, and the visual lightness and distinctive design of the coordinating Aptos Bollard.</p>
          <div className='heroTextInner'>
            <ul>
              <li>Fixtures consist of one or two luminaires on a pole 4" dia. x 12' high</li>
              <li>Pole and luminaire(s) are a single unit</li>
              <li>Pole is powdercoated aluminum</li>
              <li>Luminaire head is cast aluminum, with optic and a frosted acrylic lens</li>
              <li>Base is cast aluminum</li>
              <li>Durable powdercoat finish</li>
              <li>Performance Cree® LEDs in 3000K warm white and 4000K neutral white</li>
              <li>Downward facing illumination for reduced light pollution and glare</li>
              <li>Dimmable</li>
              <li>High recycled content; highly recyclable</li>
              <li>ETL and C-ETL listed for wet locations</li>
            </ul>
          </div>
          <p><a href="https://www.forms-surfaces.com/aptos-pedestrian" target="_NEW">LEARN MORE</a></p>
        </div>
      </div>
      </Heroes>
      <Contact
        id="contact"
        formTitle="Interested in our latest and upcoming outdoor products?"
        subtitle="Connect with a local Forms+Surfaces contact"
      />
    </Layout>
  </>
)
